import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContainersModule } from './containers/containers.module';
import { ComponentsModule } from './components/components.module';
import { PrimeNGModule } from './components/prime-ng/prime-ng.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeEs from '@angular/common/locales/es-CL';
import { registerLocaleData } from '@angular/common';
import { SharedService } from './providers/shared/shared.service';
import { ApiPrefixInterceptor } from '@interceptors/api-prefix.interceptor';
// import { EncryptBodyInterceptor } from '@interceptors/encrypt-body.interceptor';
// import { EncryptParamsInterceptor } from '@interceptors/encrypt-params.interceptor';
// import { DescryptBodyInterceptor } from '@interceptors/descrypt-body.interceptor';
import { ErrorHandlerInterceptor } from '@interceptors/error-handler.interceptor';
import { JwtInterceptor } from '@interceptors/jwt.interceptor';
import { RefreshTokenInterceptor } from '@interceptors/refresh-token.interceptor';
import { TimeoutInterceptor } from '@interceptors/timeout.interceptor';
import { RetryInterceptor } from '@interceptors/retry.interceptor';

registerLocaleData(localeEs);


@NgModule({
  declarations: [AppComponent],
  imports: [
    PrimeNGModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ContainersModule,
    ComponentsModule,
  ],
  providers: [
    SharedService,
    {
      provide: LOCALE_ID,
      useValue: 'es-CL',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
